import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";

interface BranchData {
  name: string;
  hours: number;
  salary: number;
  color: string;
}

interface BranchComparisonChartProps {
  online: { hours: number; salary: number };
  siam: { hours: number; salary: number };
  ngamwongwan: { hours: number; salary: number };
}

export function BranchComparisonChart({ online, siam, ngamwongwan }: BranchComparisonChartProps) {
  const data: BranchData[] = [
    { name: "Online", hours: online.hours, salary: online.salary, color: "hsl(var(--chart-1))" },
    { name: "Siam", hours: siam.hours, salary: siam.salary, color: "hsl(var(--chart-2))" },
    { name: "งามวงศ์วาน", hours: ngamwongwan.hours, salary: ngamwongwan.salary, color: "hsl(var(--chart-3))" },
  ];

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("th-TH", {
      style: "currency",
      currency: "THB",
      minimumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base font-medium">ชั่วโมงสอนแยกสาขา</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={data} layout="vertical" margin={{ left: 10, right: 20 }}>
              <XAxis type="number" tickFormatter={(v) => `${v} ชม.`} />
              <YAxis type="category" dataKey="name" width={80} />
              <Tooltip
                formatter={(value: number) => [`${value.toLocaleString("th-TH")} ชม.`, "ชั่วโมง"]}
                contentStyle={{ background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))" }}
              />
              <Bar dataKey="hours" radius={[0, 4, 4, 0]}>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base font-medium">เงินเดือนแยกสาขา</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={data} layout="vertical" margin={{ left: 10, right: 20 }}>
              <XAxis type="number" tickFormatter={(v) => formatCurrency(v)} />
              <YAxis type="category" dataKey="name" width={80} />
              <Tooltip
                formatter={(value: number) => [formatCurrency(value), "เงินเดือน"]}
                contentStyle={{ background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))" }}
              />
              <Bar dataKey="salary" radius={[0, 4, 4, 0]}>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
}
